module.exports = __webpack_public_path__ + "img/web-trader.6f65a64c.png";